<template>
    <div class="editor__text text">
        <button
            type="button"
            class="button button--gray"
            style="margin: 20px auto; max-width: 300px; "
            @click="back"
        >
            ‹ {{ $t('export.repair.backToBookEditing') }}
        </button>
        <div class="text__inner">
            <transition name="fade" appear>
                <div
                    v-if="parts.length"
                    class="text__container"
                    :class="{ 'text__container--rtl': isRtl }"
                >
                    <div
                        v-for="(part, index) in parts"
                        :key="part.obj.id"
                        class="text__entity-wrap"
                    >
                        <div class="text__broken-part">
                            <div style="font-size: 14px; color: #666882;">
                                <span style="margin-right: 10px;">
                                    {{ part.fixed ? '&#9989;' : '&#10060;' }}
                                </span>
                                {{ $t('misc.sentence') }}
                                {{ index + 1 }}:
                            </div>
                            <span
                                class="text__entity"
                                :class="{
                                    'is-active': isPartActive(part)
                                }"
                                @click.prevent="select(part)"
                            >
                                {{ part.obj.export_text }}
                            </span>
                            <div v-if="!part.fixed" class="text__broken-part-error">
                                {{ $t('misc.error') }}: {{ part.obj.error_message }}
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div v-if="!parts.length && !loading" class="text__container">
                <div style="text-align: center; font-size: 16px">
                    No broken parts. Everything seems alright!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { isRtlLanguage } from '@speechki-frontend/core/editor/utils';

export default {
    name: 'BrokenPartsList',
    props: {
        parts: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Object,
            default: null
        }
    },
    computed: {
        ...mapState({
            book: state => state.book.book
        }),
        editorType() {
            return this.$route.path.includes('embed') ? 'embed' : 'editor';
        },
        isRtl() {
            return isRtlLanguage(this.book.book_language);
        }
    },
    methods: {
        isPartActive(part) {
            return (
                this.selected &&
                part.pk === this.selected.id &&
                part.obj.id === this.selected.localId
            );
        },
        back() {
            this.$router.push(`/${this.editorType}/${this.book.id}`);
        },
        select(part) {
            this.$emit('selected', {
                id: part.pk,
                localId: part.obj.id,
                immutable: false
            });
        }
    }
};
</script>
